import Step from 'shepherd.js/src/types/step';
import {TourSteps} from './interface/tour-steps.interface';

export const goToPatientsStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons}: TourSteps): Step.StepOptions[] => {
    return  [{
      ...steps.default,
      id: 'patients1',
      title: '¡Vamos a registrar a tu primer paciente!',
      text: `Da clic en "Mis pacientes" para poder continuar.`,
      attachTo: {
        element:  '.l-item-0-2',
        on: 'bottom',
      },
      advanceOn: {
        selector: '.l-item-0-2',
        event: 'click'
      },
      buttons: [
        {
          ...buttons.cancel,
        }
      ],
      beforeShowPromise: () => {
        return new Promise((resolve): void => {
          setTimeout((): void => {
            resolve(true);
          }, 1000);
        });
      },
      classes: 'shepherd shepherd-open shepherd-theme-square shepherd-transparent-text',
    }];
  };
